import React, { useEffect } from 'react'
import NonFaceCrsPopup from './NonFaceCrsPopup'
import { CustomerAPI } from 'services/customer';
import { useCRS } from 'components/hooks';
import { useDispatch } from 'react-redux';
import { alertError } from 'redux/reducers/master';

function OffshoreNonFaceCRS({ code, state, close, actions, visible }) {
  const dispatch = useDispatch();
  const [crsInfo, { verifyCRS, resolveCRS, resetCRS, isRejectError }] = useCRS({
    api: CustomerAPI.checkCrsOffshoreNote,
    payload: {
      securityCode: state?.securityCode,
    },
  });

  useEffect(() => {
    if (visible) {
      (async () => {
        try {
          await verifyCRS();
        } catch (error) {
          if (!isRejectError(error)) {
            dispatch(alertError(error));
          }
        }
      })()
    }
  }, [dispatch, visible, verifyCRS, isRejectError]);

  function _onAccept() {
    resolveCRS();
    close();
    actions?.onAccept && actions.onAccept(code);
  }

  function _onCancel() {
    resetCRS();
    close();
    actions?.onCancel && actions.onCancel();
  }

  return (
    <NonFaceCrsPopup
      selfCertType={2}
      crs={crsInfo.crs}
      countryOfTaxList={crsInfo.countryOfTaxList}
      onContinue={_onAccept}
      onCancel={_onCancel}
      messageOverrides={messageOverrides}
      noTitleForReject
    />
  )
}

export default OffshoreNonFaceCRS;

const messageOverrides = {
  messageSelfCert: {
    property: {
      0: "non-face-crs.message.self-certification.offshore-note.1",
    },
  },
  messageRejectCert: {
    property: "non-face-crs.message.reject-message.offshore-note",
  },
};
